<template>
    <div v-if="onboardingUser.betaPromotion" class="betaPromotion">
        <div class="d-flex align-items-center">
            <img
                src="https://social-cloud-media.sfo2.cdn.digitaloceanspaces.com/brand/findmate/icon.png"
                class="betaPromotionIcon mr-3"
                alt=""
            />
            <div>
                <h5 class="mb-1">
                    {{ $t("The new app is here") }}
                </h5>
                <div class="small betaPromotionCopy">
                    {{
                        $t(
                            "Rebuilt from the ground up, with major improvements to chatting and video calling. Your account comes with you. Try it out and come back anytime."
                        )
                    }}
                </div>
            </div>
        </div>

        <b-btn
            @click="openBeta"
            variant="primary"
            pill
            block
            class="mt-3 font-weight-bold"
            :disabled="openingBeta"
        >
            <b-spinner v-if="openingBeta" small />
            <span v-else>{{ $t("Try it now") }}</span>
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            openingBeta: false,
        };
    },
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        async openBeta() {
            this.openingBeta = true;

            try {
                // same-tab redirect on purpose, NOT system/openBrowser: the backend
                // only sets betaPromotion for web (never cordova), and same-tab keeps
                // the browser back button as the way back to this app. the login
                // token in the url is minted per click and dies in 2 minutes.
                const response = await this.api.post("/beta/url");
                window.location.href = response.data.url;
            } catch (error) {
                this.openingBeta = false;
            }
        },
    },
};
</script>

<style scoped>
.betaPromotion {
    padding: 1.25rem;
    color: #fff;
    background: #121214;
}

.betaPromotionIcon {
    width: 3rem;
    height: 3rem;
    border-radius: 0.75rem;
    flex-shrink: 0;
}

.betaPromotionCopy {
    color: rgba(255, 255, 255, 0.6);
}
</style>
